'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.withInternals = void 0;

var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));

var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));

var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));

var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));

var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));

var _react = _interopRequireDefault(require('react'));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2['default'])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2['default'])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2['default'])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

  return _extends.apply(this, arguments);
}

var withInternals = function withInternals(WrappedComponent, config) {
  var WithInternals = /*#__PURE__*/ (function (_React$Component) {
    (0, _inherits2['default'])(WithInternals, _React$Component);

    var _super = _createSuper(WithInternals);

    function WithInternals() {
      (0, _classCallCheck2['default'])(this, WithInternals);
      return _super.apply(this, arguments);
    }

    (0, _createClass2['default'])(WithInternals, [
      {
        key: 'render',
        value: function render() {
          return _react['default'].createElement(
            WrappedComponent,
            _extends({}, this.props, {
              nextI18NextInternals: config,
            })
          );
        },
      },
    ]);
    return WithInternals;
  })(_react['default'].Component);

  WithInternals.displayName = 'withnextI18NextInternals('.concat(
    WrappedComponent.displayName || WrappedComponent.name || 'Component',
    ')'
  );
  return WithInternals;
};

exports.withInternals = withInternals;
